export const dyid = '_dyid';
export const dyidServer = '_dyid_server';
export const dySession = '_dyjsession';
export const dyNewUser = 'newUser';
export const dyPageLocation = '_dy_page_location';
export const dyGlobalControlGroup = '_dy_cs_gcg';
